var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Small } from "syf-component-library/ui/typography";
import { PromoExpirationTooltipTittle } from "../../ui/atoms/Tooltip/Tooltip.style";
var en = {
    labels: {
        accountEndingIn: "Account ending in",
        loanEndingIn: "Loan ending in",
        addNickName: "Add account nickname",
        paymentDueDate: "Payment Due Date",
        totalAmountDue: "Total Amount Due",
        nextAmountDue: "Next Amount Due",
        nextAmountMonthlyTooltip: "Includes any fees and past due amounts.",
        nextAmountPN4Tooltip: "Includes any past due amounts.",
        totalMinimumPayment: "Total Minimum Payment",
        noPaymentDue: "No Payment Due",
        forHelp: "for help.",
        creditLimit: "Credit Limit",
        currentBalance: "Current Balance",
        totalPaid: "Total Paid",
        availableToSpend: "Available to spend",
        cardLogo: "Card logo",
        totalLoanBalance: "Total Loan Balance",
        loanMaturityDate: "Loan Maturity Date",
        totalLoanBalanceTooltip: "The Total Loan Balance may change for various reasons (e.g. payments and returns). If applicable, the Total Loan Balance may increase as items are fulfilled.",
        totalLoanBalanceSecuredInstallment: function (_a) {
            var telephoneNumber = _a.telephoneNumber;
            return (_jsxs(_Fragment, { children: ["This is the remaining principal balance still owed on your loan; it is not the amount required to pay the loan in full. To get a current payoff quote please call our Customer Service team ", telephoneNumber, "."] }));
        },
        totalRemaining: "Total Remaining",
        monthlyPayment: "Monthly Payment",
        currentBalanceTooltip: "May not reflect recent transactions.",
        unavailable: "Unavailable",
        loanAmount: "Loan Amount",
        amountFinanced: "Amount Financed",
        nextScheduledPaymentAmount: "Next Scheduled Payment Amount",
        nextScheduledPaymentDate: "Next Scheduled Payment Date",
        loanNickNameHeader: "Add loan nickname",
        loanNicknameText: "Add a nickname to this loan for quick reference. For example: “Kitchen remodel” or “Washing Machine”",
        makeAPaymentBtn: "Make a Payment",
        registerAccountBtn: "Register Account",
        manageYourCreditBalanceBtn: "Manage Your Credit Balance",
        makePaymentBtn: "Make Payment",
        detailsBtn: "Details",
        activityBtn: "Activity",
        statementsBtn: "Statements",
        rewardsBtn: "Rewards",
        accountServicesBtn: "Account Services",
        promotionsBtn: "Promotions",
        generalError: "Something went wrong",
        nicknameError: "We can’t update your nickname right now. Please try again later.",
        noAccountCard: "No Account Card available.",
        accountNickname: "Account Nickname",
        overlayHeading: "Your attention is required.",
        overlayText: "There is an issue with your account. Please contact customer service at",
        cardActivationBtn: "Activate Card",
        moreBtn: "More",
        totalDue: "Total Due",
        introRateLoanTooltip: function () {
            return (_jsxs(_Fragment, { children: [_jsx(PromoExpirationTooltipTittle, { children: "This is an Intro Rate Loan" }), _jsx(Small, __assign({ isInline: true }, { children: "Your loan has an intro rate with a set payment. Your rate and payment amount will increase when the intro period ends." }))] }));
        },
        beforePromoExpirationTooltip: function (_a) {
            var date = _a.date;
            return (_jsxs(_Fragment, { children: [_jsx(PromoExpirationTooltipTittle, { children: "This is a Waived interest loan" }), _jsxs(Small, __assign({ isInline: true }, { children: ["If you pay the amount financed plus any fees off before", " ", _jsx(Small, __assign({ isInline: true, weight: "bold" }, { children: date })), ", all interest will be waived."] }))] }));
        },
        afterPromoExpirationTooltip: function (_a) {
            var date = _a.date;
            return (_jsxs(_Fragment, { children: [_jsx(PromoExpirationTooltipTittle, { children: "Promotional period has ended" }), _jsxs(Small, __assign({ isInline: true }, { children: ["The promotional period for this loan ended on", " ", _jsx(Small, __assign({ isInline: true, weight: "bold" }, { children: date })), "."] }))] }));
        },
        loanPaidOffOverlayHeading: "Congrats!",
        loanPaidOffOverlayText: "This loan is paid off.",
    },
    autopay: {
        text: "Autopay",
        on: "ON",
        off: "OFF",
    },
    button: {
        back: "BACK",
        save: "SAVE",
        cancel: "CANCEL",
        close: "CLOSE",
        paymentOptions: "View Payment Options",
        paymentPlan: "View Payment Plan",
    },
    predelivery: {
        title: "Your loan is approved but still processing",
        subTitle: "Loan details will be provided when available.",
    },
    error: {
        title: "Something went wrong.",
        subTitle: "Please refresh the page to try again.",
        error: "Error",
    },
    loanPaidOff: {
        title: "This loan is already paid off.",
        heading: "You have no payments to make at this time.",
        subHeading: "For questions on your account, please contact Customer Service (1-866-220-9432) during hours of operation.",
    },
};
export default en;
//# sourceMappingURL=en.js.map